import script from "./gameSearchPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./gameSearchPopup.vue?vue&type=script&lang=ts&setup=true"

import "./gameSearchPopup.vue?vue&type=style&index=0&id=595f172c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595f172c"]])

export default __exports__